import { render, staticRenderFns } from "./FlightSelector.vue?vue&type=template&id=00286b5a&"
import script from "./FlightSelector.vue?vue&type=script&lang=js&"
export * from "./FlightSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports